import { render, staticRenderFns } from "./MySelect.vue?vue&type=template&id=55a0ac60&"
import script from "./MySelect.vue?vue&type=script&lang=js&"
export * from "./MySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports